<page-header title="SEARCH"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div>
      <search [fluid]="true"></search>
    </div>
  </ng-template>
  <ng-template let-row="row" #code>
    <a [routerLink]="['/licenses', row.get('businessId')]">{{
      row.get('businessCode')
    }}</a>
  </ng-template>
  <ng-template let-row="row" #entityCodePayable>
    <a
      *ngIf="row.get('type') === 'RDN_PAYABLE'"
      [routerLink]="['/properties', row.get('propertyId')]"
      >{{ row.get('propertyCode') }}</a
    >

    <a
      *ngIf="row.get('type') === 'BUSINESS_PAYABLE'"
      [routerLink]="['/licenses', row.get('businessId')]"
      >{{ row.get('businessCode') }}</a
    >

    <a
      *ngIf="row.get('type') === 'COMPOUND_PAYABLE'"
      [routerLink]="['/compounds', row.get('compoundId')]"
      >{{ row.get('compoundCode') }}</a
    >
  </ng-template>
  <ng-template let-row="row" #entityCodePayment>
    <a
      *ngIf="row.getIn(['payable', 'type']) === 'RDN_PAYABLE'"
      [routerLink]="['/properties', row.getIn(['payable', 'propertyId'])]"
      >{{ row.getIn(['payable', 'propertyCode']) }}</a
    >

    <a
      *ngIf="row.getIn(['payable', 'type']) === 'BUSINESS_PAYABLE'"
      [routerLink]="['/licenses', row.getIn(['payable', 'businessId'])]"
      >{{ row.getIn(['payable', 'businessCode']) }}</a
    >

    <a
      *ngIf="row.getIn(['payable', 'type']) === 'COMPOUND_PAYABLE'"
      [routerLink]="['/compounds', row.getIn(['payable', 'compoundId'])]"
      >{{ row.getIn(['payable', 'compoundCode']) }}</a
    >
  </ng-template>
  <ng-template let-row="row" #propertyCode>
    <a [routerLink]="['/properties', row.get('propertyId')]">{{
      row.get('propertyCode')
    }}</a>
  </ng-template>
  <ng-template let-row="row" #generatedOn>
    {{ row.get('generatedOn') | formatDate }}
  </ng-template>
  <ng-template let-row="row" #arrears>
    {{ row.get('arrears') }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #amount>
    {{ row.get('amount') }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #penalty>
    {{ row.get('penalty') }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #totalPayable>
    {{ row.get('totalPayable') }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #totalGroupDiscount>
    <span *ngIf="row.get('type') !== 'BUSINESS_PAYABLE'"
      >{{ row.get('totalGroupDiscount') }} {{ currency }}</span
    >
  </ng-template>
  <ng-template let-row="row" #discount>
    {{ row.get('discount') }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #total>
    {{ row.getIn(['balance', 'totalPayable']) }} {{ currency }}
  </ng-template>
  <ng-template let-row="row" #notes>
    <span class="notes-truncate" [title]="row.get('notes')">{{
      row.get('notes')
    }}</span>
  </ng-template>
  <ng-template let-row="row" #paymentDate>
    {{ row.get('paymentDate') | formatDate }}
  </ng-template>
  <ng-template let-row="row" #transactionId>
    <span class="bank-truncate" [title]="row.get('transactionId')">{{
      row.get('transactionId')
    }}</span>
  </ng-template>
</app-table>
